import { render } from "./MediaComponent.vue?vue&type=template&id=625da9bc"
import script from "./MediaComponent.vue?vue&type=script&lang=js"
export * from "./MediaComponent.vue?vue&type=script&lang=js"

import "./MediaComponent.vue?vue&type=style&index=0&id=625da9bc&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__